import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEraserIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.255 15.55a.5.5 0 0 0 .145-.35c0-.13-.05-.26-.145-.35L17.15 5.745a.5.5 0 0 0-.35-.145c-.13 0-.26.05-.35.145L12.345 9.85l9.805 9.805zl1.695 1.7-7.55 7.55h7.2c.665 0 1.2.535 1.2 1.2s-.535 1.2-1.2 1.2H10.525c-.85 0-1.665-.335-2.265-.935L2.45 20.45a2.895 2.895 0 0 1 0-4.1l12.3-12.3a2.895 2.895 0 0 1 4.1 0l9.1 9.1a2.895 2.895 0 0 1 0 4.1zm-5.8 5.8-9.805-9.805-6.505 6.505A.5.5 0 0 0 4 18.4c0 .13.05.26.145.35l5.815 5.815c.15.15.355.235.565.235h6.15c.21 0 .415-.085.565-.235z" })
});
export default SvgEraserIcon;
